import { Box } from '@mui/material';
import { BoxProps } from '@mui/system';
import * as React from 'react';
import { CerebroSelectableIcon, CerebroSelectableIconProps } from '.';

const Context = React.createContext<IconRadioGroupContext | null>(null);

export const IconRadioGroup: React.FC<IconRadioGroupProps> = ({ name, error, value, onChange, children, ...props }) => {
	const context: IconRadioGroupContext = {
		name,
		error,
		selectedValue: value,
		onSelectedValueChange: newSelectedValue => onChange({ target: { name, value: newSelectedValue } }),
	};

	return (
		<Context.Provider value={context}>
			<Box {...props}>{children}</Box>
		</Context.Provider>
	);
};
function useIconRadioGroup() {
	var context = React.useContext(Context);

	if (context == null) throw Error('You tried to use an <IconRadioButton/> outside of an <IconRadioGroup/>!');

	return context;
}

export const IconRadioButton: React.FC<IconRadioButtonProps> = ({ value, ...props }) => {
	const { name, error, selectedValue, onSelectedValueChange } = useIconRadioGroup();

	const selected = selectedValue == value;
	const onChange = () => onSelectedValueChange(value);

	return <CerebroSelectableIcon name={name} error={error} value={selected} onChange={onChange} {...props} />;
};

// Like a partial React.ChangeEvent because formik falls back to handling any value it receives on change as an event if it isn't a string.
export interface IconRadioGroupChangeEvent {
	target: {
		name: string;
		value: string;
	};
}

interface IconRadioGroupProps extends Omit<BoxProps, 'onChange'> {
	name: string;
	value: string;
	error: boolean;
	onChange: (event: IconRadioGroupChangeEvent) => void;
}

interface IconRadioGroupContext {
	name: string;
	error: boolean;
	selectedValue: string;
	onSelectedValueChange: (newSelectedValue: string) => void;
}

type IconRadioButtonProps = Omit<CerebroSelectableIconProps, 'value' | 'onChange' | 'name' | 'error'> & {
	value: string;
};
